<div class="mst-dialog__inner stack col" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <ng-content></ng-content>
</div>
